export default __webpack_public_path__ + "static/media/Ethereum-Symbole.d0fab10d.png";